import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ComponentSize, DEFAULT_COMPONENT_SIZE } from '@examdojo/core/model';
import { SingleSelectComponent } from '@examdojo/core/select';
import {
  getReferenceQuestionStatusLabel,
  REFERENCE_QUESTION_STATUS,
  ReferenceQuestionStoreModel,
} from '../reference-question.model';

@Component({
  selector: 'dojo-reference-question-status-selector',
  template: `
    <dojo-single-select
      [formCtrl]="formCtrl()"
      [optionLabel]="'label'"
      [optionValue]="'value'"
      [options]="options"
      [label]="label()"
      [size]="size()"
    />
  `,
  imports: [SingleSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferenceQuestionStatusSelectorComponent {
  readonly formCtrl = input.required<FormControl<ReferenceQuestionStoreModel['status']>>();
  readonly label = input<string>();
  readonly size = input<ComponentSize>(DEFAULT_COMPONENT_SIZE);

  readonly options = REFERENCE_QUESTION_STATUS.map((status) => ({
    value: status,
    label: getReferenceQuestionStatusLabel(status),
  }));
}
